module.exports = __webpack_public_path__ + "img/iStock-1131158829.2ef4ec80.jpg";